var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 21.5,
    stroke: "#07143F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4167 30.75H13.25V19.9166H17.4167V30.75ZM24.9167 23.25C24.4746 23.25 24.0507 23.4256 23.7382 23.7381C23.4256 24.0507 23.25 24.4746 23.25 24.9166V30.75H19.0833V19.9166H23.25V21.1541C24.1802 20.3657 25.3557 19.9253 26.575 19.9083C29.0433 19.9083 30.75 21.7416 30.75 25.2041V30.75H26.5833V24.9166C26.5833 24.4746 26.4077 24.0507 26.0952 23.7381C25.7826 23.4256 25.3587 23.25 24.9167 23.25ZM17.4167 16.1666C17.4167 16.5787 17.2945 16.9815 17.0656 17.3241C16.8366 17.6667 16.5113 17.9337 16.1306 18.0914C15.7499 18.2491 15.331 18.2903 14.9269 18.2099C14.5228 18.1296 14.1516 17.9311 13.8602 17.6398C13.5688 17.3484 13.3704 16.9772 13.29 16.5731C13.2096 16.169 13.2509 15.7501 13.4086 15.3694C13.5663 14.9887 13.8333 14.6633 14.1759 14.4344C14.5185 14.2055 14.9213 14.0833 15.3333 14.0833C15.8859 14.0833 16.4158 14.3028 16.8065 14.6935C17.1972 15.0842 17.4167 15.6141 17.4167 16.1666Z",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.605817ba95d96546756a5189c50f8c35.svg";
export { ForwardRef as ReactComponent };